interface MarkdownMessageProps {
  content: string;
}

export const MarkdownMessage = ({ content }: MarkdownMessageProps) => {
  // Convertir les liens markdown [texte](url) en liens HTML cliquables
  const renderWithLinks = (text: string) => {
    // Désactiver les liens cliquables: conserver uniquement le libellé des liens markdown
    // Exemple: "[Voir la page](https://exemple.com)" => "Voir la page"
    return text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1');
  };

  return (
    <div className="whitespace-pre-wrap">
      {renderWithLinks(content)}
    </div>
  );
};
